<div class="main-container">

    <div class="license-report-container">

        <div class="license-report-header">
            {{ "LicenseReport" | NTSTranslate }}
        </div>

        <div class="license-report-content">

            <nts-generate-cost-review-data-modal-container [viewModel]="viewModel" />

        </div>

        <div class="license-report-footer">
            <nts-filled-button [type]="3" [title]="viewModel.resultCostReviewDataCommand.displayName$ | async"
                [label]="viewModel.resultCostReviewDataCommand.displayName$ | async"
                [icon]="(viewModel.resultCostReviewDataCommand.iconClass$ | async)"
                [isLoading]="viewModel.resultCostReviewDataCommand.loading$ | async"
                [isDisabled]="!(viewModel.canUploadFile() | async)"
                (onClicked)="viewModel.resultCostReviewDataCommand.execute()">
            </nts-filled-button>

        </div>

    </div>

</div>
